<template>
  <div class="app">
    <div class="m-viewport" id="mainView">

        <div class="logo-view">
          <h2 class="logo_1 sprite sprite-logo_m3"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
          <h2 class="logo_2 sprite sprite-logo_16th"><a href="https://www.m3guo.com/activity/202609/16year-home-v5es/" target="_blank" rel="noopener noreferrer"></a></h2>
        </div>
        
        <div class="u-links">
            <div class="btn-index sprite sprite-btn-web">
                <a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a>
            </div>
            <div class="btn-dl sprite sprite-btn-dl">
              <a href="https://www.m3guo.com/v2/download/client/" target="_blank" rel="noopener noreferrer"></a>
            </div>
        </div>
        
        <div class="u-btn copyright">
            <!-- todo -->
        </div>

        <div class="page-main-title"></div>

        <!-- <div class="side-nav">
            <div class="header"></div>
            <div class="body" :class="{'sm' : ($store.state.userinfo.uflag & 2) != 2}">
                <div class="u-btn welcome" @click="$welcome_modal()">
                    <div class="layer-star s-1"></div>
                    <div class="layer-star s-2"></div>
                </div>
            </div>
        </div> -->
        
        <loading v-show="Loading"/>
     
        <div class="page-body" v-if="ready">
            <div class="m-user">
                <user-info/>
            </div>

            <div class="page-wrapper">
                <lucky-money ref="hb" class="page-item"/>
                <web-share class="page-item" style="margin-top: 60px;"/>
                <!-- <game-event class="page-item" style="margin-top: 130px;"/>
                <invite-view class="page-item" style="margin-top: 160px;"/> -->
                <patch-view class="page-item" style="margin-top: 120px;"/>
                <streamer-view class="page-item"/>
                <rule-view class="page-item"/>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'mainview',
    components: {
        //'user-info': () => import('@/components/UserInfo.vue'),
        loading: () => import('@/components/loading.vue'),
        'lucky-money': () => import('@/views/lucky.money.vue'),
        'web-share': () => import('@/views/web.share.vue'),
        // 'game-event': () => import('@/views/game.event.vue'),
        'streamer-view': () => import('@/views/streamer.vue'),
        'patch-view': () => import('@/views/patch.vue'),
        'rule-view': () => import('@/views/rule.vue')        
    },
    computed : {
        ...mapState(['Loading'])
    },    
    props : {
        ready : {
            default : false,
        },
    },  
}
</script>

<style lang="scss" scoped>
/* 导入全局样式 */
@import '~@/assets/css/global.css';
@import '~@/assets/css/ui.css';
@import '~@/assets/css/sprite_pc.css';

@keyframes play_pc {
  from { background-position: 0 0; }
  to { background-position: 0 -816px; }
}

@keyframes main_title_in {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes main_title_float {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-10px) scale(1.015);
  }
}

.m-viewport{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    // height: 8000px;
    margin: 0 auto 0;
    box-sizing: border-box;
    font-size: 16px;
    background-color: #341e0d;
    color: #dec291;
    overflow-x: hidden;
    overflow-y: hidden;
    // font-family: "HYChangLiSongKeBenJ";

    b{
        font-weight: 400;
        color: #26c7da;        
    }
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 2%;
    top:30px;
    z-index: 3;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.u-links{
    display: flex;
    position: absolute;
    right: 4%;
    top: 30px;
    z-index: 3;  
}

.u-links a{
    display: block;
    width: 100%;
    height: 100%;
}

.page-main-title{
    position: absolute;
    left: 50%;
    top: 42px;
    width: 526px;
    height: 758px;
    margin-left: -700px;
    background-image: url(~@/assets/images/pc/main-title.png);
    transform-origin: center top;
    animation: main_title_in .8s ease-out both, main_title_float 3.6s ease-in-out .8s infinite;
    z-index: 3;
}

.side-nav{
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;  
    width: 125px;

    .header{
        width: 125px;
        height: 124px;
        margin: 0 auto;
        background-image: url(~@/assets/images/pc/icon-nav.png);
    }

    .body{
        padding-top: 10px;
        height: 242px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/pc/nav-line.png);
        background-position: center bottom;
        background-repeat: no-repeat; 
        
        &.sm{
            height: 142px;
        }
    }

    .u-btn{
        position: relative;
        margin: 0 auto;

        &.welcome{
            width: 70px;
            height: 68px;            
            background-image: url(~@/assets/images/pc/btn-welcome.png);

            &:hover{
                background-image: url(~@/assets/images/pc/btn-welcomeD.png);
            }

            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top : 50%;
                transform: translate(-50%,-50%);
                width: 90px;
                height: 68px;
                background-image: url(~@/assets/images/pc/light-keyframes.png);
                animation: play_pc 3s steps(12) infinite;
            }

            .layer-star{
                position: absolute;
                width: 17px;
                height: 22px;
                background-image: url(~@/assets/images/pc/star-1.png);

                &.s-1{
                    left: -8px;
                    bottom: 10px;
                    animation: breath 6s ease-in-out infinite;
                }

                &.s-2{
                    right: -8px;
                    top: 10px;
                    animation: breath 5s ease-in-out infinite;
                }
            }

            // &::before {
            //     content: "";
            //     position: absolute;
            //     display: block;
            //     top: -10px;
            //     left: -50%;
            //     bottom: -10px;
            //     width: 20px;
            //     transform: rotate(15deg);
            //     background-image: linear-gradient(to right, rgba(255, 255, 255, 0), white);
            //     animation: flashing 4000ms ease 2000ms infinite;
            // }


        }


        &.misc{
            width: 61px;
            height: 63px;            
            background-image: url(~@/assets/images/pc/btn-misc.png);

            &:hover{
                background-image: url(~@/assets/images/pc/btn-miscD.png);
            }
        }
    }
}

.page-body{
    position: relative;
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    height: calc(9000px - 42px);
    padding-top: 835px;
    background-repeat: no-repeat;
    background-position: center -42px;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
    background-image: url(~@/assets/images/pc/body.jpg);   
}

.m-user{
    width: 696px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto;
    text-align: center;
    background-image: url(~@/assets/images/pc/bg-userinfo.png); 
}

.page-wrapper{
    margin: 67px auto 0;

}
</style>
